import { jsxs, jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Image } from "@zillow/constellation";
import { withPreload, Upsell } from "@zillow/zrs-cms";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
const ImagePreload = withPreload(Image);
const BlockUpsell = ({
  attrs: {
    button = "Learn More",
    body,
    color = "blue",
    heading,
    id,
    image,
    legal,
    size = "xs",
    url
  }
}) => /* @__PURE__ */ jsxs(React.Fragment, { children: [
  image && /* @__PURE__ */ jsx(StructuredData, { data: {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    "contentUrl": image.src,
    "caption": image.alt,
    "height": image.height,
    "width": image.width
  } }),
  /* @__PURE__ */ jsx(FullHeightUpsell, { body, button, color, heading, id, image: image ? /* @__PURE__ */ jsx(ImagePreload, { src: image.src, width: image.width, height: image.height, alt: image.alt, decoding: image.decoding, loading: "lazy" }) : void 0, legal, size, url })
] });
const FullHeightUpsell = /* @__PURE__ */ styled(Upsell).withConfig({
  displayName: "Upsell__FullHeightUpsell",
  componentId: "sc-vfzerr-0"
})(["height:100%;"]);
BlockUpsell.propTypes = {
  attrs: PropTypes.shape({
    body: PropTypes.string,
    button: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      loading: PropTypes.string
    }),
    legal: PropTypes.string,
    size: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};
export {
  BlockUpsell as default
};
